// recoveryDetect.js
//
// MUST be the FIRST import in src/index.js (before anything that creates the Supabase client).
//
// When a user clicks the link in a "reset your password" e-mail, Supabase sends the browser back to the app with the
// session in the URL hash (#access_token=...&type=recovery). The Supabase client reads and then clears that hash while
// it initialises, so by the time React renders it is already gone. This module runs earlier and only records what the
// URL looked like when the page was opened; it never touches or stores any token.

const fragment = typeof window !== 'undefined' ? window.location.hash || '' : ''
const query = typeof window !== 'undefined' ? window.location.search || '' : ''
const both = `${fragment}&${query}`

// Opened from a valid password-reset link.
export const RECOVERY_LINK_OPENED = /[#&?]type=recovery(?:&|$)/.test(both)

// Opened from an auth link that Supabase rejected (for example an expired or already used reset link).
export const RECOVERY_LINK_PROBLEM = !RECOVERY_LINK_OPENED && /[#&?]error_code=/.test(both)
